import { createSlice } from '@reduxjs/toolkit';
import { getNewStateByAttr, getNewStateById } from './entities';
import { fetchGames } from './games';
const initialState = {
    byId: {},
    byLeague: {},
    byProvider: {},
    bySeason: {},
    status: 'init'
};
function applyTeamsState(state, teams) {
    state.byId = getNewStateById(state.byId, teams);
    state.byLeague = getNewStateByAttr(state.byId, 'league');
    state.byProvider = getNewStateByAttr(state.byId, 'provider');
    state.bySeason = getNewStateByAttr(state.byId, 'season');
}
const teamsSlice = createSlice({
    name: 'teams',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchGames.fulfilled, (state, action) => {
            applyTeamsState(state, action.payload.teams);
        });
    }
});
export const teamsReducer = teamsSlice.reducer;
